import { useState } from 'react';

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              SALVI SAS
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              Features
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              How It Works
            </button>
            <button onClick={() => scrollToSection('security')} className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              Security
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap">
              Contact
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-teal-600 text-white px-6 py-2.5 rounded-full hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap">
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-teal-600 transition-colors text-left cursor-pointer whitespace-nowrap">
                Features
              </button>
              <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-teal-600 transition-colors text-left cursor-pointer whitespace-nowrap">
                How It Works
              </button>
              <button onClick={() => scrollToSection('security')} className="text-gray-700 hover:text-teal-600 transition-colors text-left cursor-pointer whitespace-nowrap">
                Security
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-teal-600 transition-colors text-left cursor-pointer whitespace-nowrap">
                Contact
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-teal-600 text-white px-6 py-2.5 rounded-full hover:bg-teal-700 transition-colors text-center cursor-pointer whitespace-nowrap">
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
